export default () => ({
    swiper: null,
    init: function () {

        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            /*autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },*/
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            }
        });

        // Добавляет класс swiper-buttons-disabled, если обе кнопки навигации неактивны
        this.swiper.on('slidesUpdated', function (swiper)  {
            if (swiper.navigation.nextEl && this.navigation.prevEl) {
                if (swiper.navigation.nextEl.classList.contains('swiper-button-disabled') &&
                    swiper.navigation.prevEl.classList.contains('swiper-button-disabled')) {
                    swiper.el.classList.add('swiper-buttons-disabled');
                } else {
                    swiper.el.classList.remove('swiper-buttons-disabled');
                }
            }
        });
    }
})
